import React from 'react';
import PropTypes from 'prop-types';

import { getPagePath, withLocales } from '@spotahome/soyuz/client';
import { localesShape } from '@spotahome/soyuz/shapes';

import { Footer as FooterComponent } from '@spotahome/ui-library';

function handleHelpClick(e) {
  e.preventDefault();
  if (typeof zE !== 'undefined') {
    zE.activate({ hideOnClose: true });
  }
}

class Footer extends React.Component {
  static contextTypes = {
    server: PropTypes.shape({
      currentRoute: PropTypes.string
    }),
    request: PropTypes.shape({
      params: PropTypes.object
    })
  };

  static propTypes = {
    locales: PropTypes.shape(localesShape).isRequired
  };

  updateURL = locale => {
    const queryString = window.location.search;
    const currentRoute = this.context.server.currentRoute;
    const params = this.context.request.params;

    window.location =
      getPagePath(currentRoute, { locale, params }) + queryString;
  };

  render() {
    return (
      <FooterComponent
        help={{
          onClick: handleHelpClick
        }}
        locales={{
          current: this.props.locales.current,
          onChange: this.updateURL
        }}
        apps={{
          android: {
            link: 'https://spotahome.app.link/android_footer_listing',
            eventCategory: 'app-promotion',
            eventAction: 'footer-icon-android',
            eventLabel: 'open'
          },
          ios: {
            link: 'https://spotahome.app.link/ios_footer_listing',
            eventCategory: 'app-promotion',
            eventAction: 'footer-icon-ios',
            eventLabel: 'open'
          }
        }}
        icons={{
          prs: {
            icon:
              'https://dt1hcwwsvdknv.cloudfront.net/8ecb241ff0d06d1628f6d20c0ba3bc7d525e2022/images/footer_image/prs.svg'
          },
          cmp: {
            icon:
              'https://dt1hcwwsvdknv.cloudfront.net/8ecb241ff0d06d1628f6d20c0ba3bc7d525e2022/images/footer_image/cmp.png'
          }
        }}
      />
    );
  }
}

export default withLocales()(Footer);
